import { GenericPaginatedListResponse } from "./main";
import { Profile } from "./user";

export interface Notification extends PushData {
  id: number;
  targetType?: string; // target 관련 데이터는 code !== 'PROMOTION' 일 경우에만
  senderProfile: Profile | null;
  createdAt: string;
  formatData: {
    inAppContent: {
      username: string;
    }
  };
  isRead?: boolean;
}

export interface NotifiactionPaginatedListResponse extends GenericPaginatedListResponse {
  data: Notification[];
}

/** Push 알림 종류 */
export enum PushCode {
  MBTI_GUEST_QUIZ_CREATED = 'MBTI_GUEST_QUIZ_CREATED', // 내 MBTI 퀴즈를 풀었을 때 알림 코드
  MBTI_FRIEND_HOST_QUIZ_CREATED = 'MBTI_FRIEND_HOST_QUIZ_CREATED', // 친구가 새 MBTI 퀴즈를 만들었을 때 알림 코드
  FAVOUR_TOURNAMENT_FRIEND_HOST_QUIZ_CREATED = 'FAVOUR_TOURNAMENT_FRIEND_HOST_QUIZ_CREATED', // 친구가 새 호불호 월드컵 퀴즈를 만들었을 때 알림 코드
  FAVOUR_TOURNAMENT_GUEST_QUIZ_CREATED = 'FAVOUR_TOURNAMENT_GUEST_QUIZ_CREATED', // 내 호불호 월드컵 퀴즈를 풀었을 때 알림 코드
  FEATURE_FAVOUR_TOURNAMENT = 'FEATURE_FAVOUR_TOURNAMENT', // 호불호 퀴즈 새로운 주제 추가시 알림 코드
  PROMOTION = 'PROMOTION', // 새로운 기능 / 프로모션
  ASK_COMMENTED = 'ASK_COMMENTED', // 누군가 내 에스크에 댓글 달았을 때 알림 코드
  MY_MBTI_TYPE_ASK_CREATED = 'MY_MBTI_TYPE_ASK_CREATED', // 내 MBTI에 관한 에스크가 생성되었을 때
  SURVEY_CREATED = 'SURVEY_CREATED', // 새 서베이가 생성되었을 때
  MBTI_IDEAL_TYPE_FRIEND_QUIZ_CREATED = 'MBTI_IDEAL_TYPE_FRIEND_QUIZ_CREATED', // 친구가 이상형 MBTI 생성했을 떄
  MBTI_IDEAL_TYPE_GUEST_MATCH_CREATED = 'MBTI_IDEAL_TYPE_GUEST_MATCH_CREATED', // 내 이상형 MBTI를 누군가가 참여했을 떄
  MBTI_BEST_FRIEND_FRIEND_QUIZ_CREATED = 'MBTI_BEST_FRIEND_FRIEND_QUIZ_CREATED', // 친구가 친친 MBTI 생성했을 떄
  MBTI_BEST_FRIEND_GUEST_MATCH_CREATED = 'MBTI_BEST_FRIEND_GUEST_MATCH_CREATED', // 내 친친 MBTI를 누군가가 참여했을 떄
  IMAGE_GAME_REPLY = 'IMAGE_GAME_REPLY',
  SIGNAL_RECEIVED = 'SIGNAL_RECEIVED', //  다른 사용자로부터 새로운 시그널 수신
  SIGNAL_CONNECTED = 'SIGNAL_CONNECTED', // 시그널이 통했을 때
  SIGNAL_REPLIED = 'SIGNAL_REPLIED', // 다른 사용자로부터 새로운 답장 수신
  CABINET_LETTER_RECEIVED = 'CABINET_LETTER_RECEIVED', // 다른 사용자로부터 새로운 편지 수신
  LOG_POST_CHOSEN = 'LOG_POST_CHOSEN', // 로그 포스트 지목받음
  LOG_POST_CORRECT = 'LOG_POST_CORRECT', // 친구가 내 로그 맞힘
  LOG_POST_INCORRECT = 'LOG_POST_INCORRECT', // 내 로그가 다른 사람의 로그로 지목됨
  FRIEND_REQUEST = 'FRIEND_REQUEST', // 친구 요청
  FRIEND_ACCEPT = 'FRIEND_ACCEPT', // 친구 수락
  GROUP_CHEMI_STARTED = 'GROUP_CHEMI_STARTED', // 그룹케미 시작되었을 때
}

/** push click시, naviagtion에 필요한 데이터 */
export interface PushData {
  key: string;
  code: PushCode; // push 종류
  title: string; // push title
  content: string; // push description
  inAppContent: string; // 인앱에서 보여줄 description
  moveTo?: string; // front기준 이동할 url. 서버에서 moveTo를 포함해서 보내주면 최우선적으로 이동. 없는 경우 ''.
  targetId?: string; // 이동할 target의 id. 없는 경우 ''.
}
